export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [0];

export const dictionary = {
		"/(site)": [3,[2]],
		"/(site)/board/rei": [4,[2]],
		"/(site)/cards": [5,[2]],
		"/(site)/gear": [6,[2]],
		"/(site)/gm": [7,[2]],
		"/(site)/ids": [8,[2]],
		"/player": [23],
		"/(site)/script": [9,[2]],
		"/(site)/script/customScript": [10,[2]],
		"/(site)/script/overview": [11,[2]],
		"/(site)/translations": [12,[2]],
		"/(site)/wiki/character/[id]": [13,[2]],
		"/(site)/wiki/incidents": [15,[2]],
		"/(site)/wiki/incident/[id]": [14,[2]],
		"/(site)/wiki/keyword/[id]": [16,[2]],
		"/(site)/wiki/plot/[id]": [17,[2]],
		"/(site)/wiki/roles": [19,[2]],
		"/(site)/wiki/role/[id]": [18,[2]],
		"/(site)/wiki/tag/[id]": [20,[2]],
		"/(site)/wiki/tragedys": [22,[2]],
		"/(site)/wiki/tragedy/[id]": [21,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';